import React from 'react'

const TermsPage = () =>
  <div className="page">
    Terms And Conditions
  </div>

export default TermsPage
